export default __webpack_public_path__ + "static/media/objednanie_kruzok.c5df1f2c.svg";